import { useCallback, useEffect, useState } from "react"

/**
 * Listendichte des Posteingangs (Schritt H).
 *
 * Gemerkt wird im localStorage, nicht am Tenant: die Einstellung haengt am
 * Bildschirm, vor dem jemand sitzt, nicht am Mandanten, den er gerade
 * ansieht. Wer auf einem 13-Zoll-Laptop kompakt eingestellt hat, will das
 * auch beim naechsten Tenant.
 */
export const DENSITIES = ["compact", "normal", "cozy"] as const
export type Density = (typeof DENSITIES)[number]

const KEY = "ev2-density"

function lesen(): Density {
  try {
    const v = localStorage.getItem(KEY)
    return (DENSITIES as readonly string[]).includes(v || "") ? (v as Density) : "normal"
  } catch {
    return "normal"
  }
}

export function useListDensity(): [Density, (d: Density) => void] {
  const [density, setDensity] = useState<Density>(lesen)

  useEffect(() => {
    try { localStorage.setItem(KEY, density) } catch { /* Privatmodus */ }
  }, [density])

  return [density, useCallback((d: Density) => setDensity(d), [])]
}

/** CSS-Klasse fuer den Zeilen-Container. */
export function densityClass(d: Density): string {
  return `density-${d}`
}
